export default __webpack_public_path__ + "static/media/pushnoti-icon.28fd130e.svg";